import {
  authReq
} from '@/utils/http'
import axios from 'axios'

const getUsers = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/user', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const migrateAgent = (userid, agentid) => {
  return authReq.post('/api/v1/user/migrate_agent', {
    userid, agentid
  })
}

const getAreas = (page, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/user/area', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const getStores = (page, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/user/store', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const getCloudLog = (date) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  return axios.get(`/p/v1/cloud/log/amk.business.backend-web_${date}`, {
    responseType: 'blob',
    timeout: 300000,
    headers: {
      'x-access-token': userInfo.token,
      'secret': userInfo.secret
    }
  }).then(res => res.data)
}

export default {
  getUsers,
  migrateAgent,
  getAreas,
  getStores,
  getCloudLog
}



// WEBPACK FOOTER //
// ./src/api/userApi.js